var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-link',{ref:`property:link-ref:${_vm.property.property_id}`,attrs:{"before_navigation":_vm.before_navigation,"route_name":_vm.is_placeholder ? '' : '/detail',"wrap":'div',"css_class":'suggestions__pad',"as_default":_vm.get_config('guiSettings.openDetailNewTab', false)},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('vb-card',{attrs:{"card":{
        image:
          _vm.property.thumbnail_url ||
          '/assets/images/common/statics/room_placeholder.png',
        image_fallback: '/assets/images/common/statics/room_placeholder.png',
        title: _vm.property.name,
        title_popover: _vm.property.name,
        style: {
          overflow: 'hidden',
        },
        subtitle: _vm.is_placeholder ? '---' : _vm.property_location,
        subtitle_class: 'text-info small semibold text-nowrap text-truncate',
        subtitle_icon: {
          name: 'pin',
          color: _vm.sass('info'),
          size: 13,
        },
        variant: 'vertical',
        ..._vm.card,
      }},on:{"click_image":(e) => {
          if (!_vm.is_placeholder) {
            _vm.$refs[`property:link-ref:${_vm.property.property_id}`].navigate(
              e || {},
            );
          }
        },"click_title":(e) => {
          if (!_vm.is_placeholder) {
            _vm.$refs[`property:link-ref:${_vm.property.property_id}`].navigate(
              e || {},
            );
          }
        }},scopedSlots:_vm._u([(_vm.property.ratings && _vm.property.ratings.property)?{key:"title-badge",fn:function(){return [_c('div',{staticClass:"compact_pad__head-star"},[_c('b-form-rating',{attrs:{"no-border":"","inline":"","readonly":"","size":"sm","variant":"secondary","value":_vm.property.ratings.property.rating}})],1)]},proxy:true}:null,{key:"badge",fn:function(){return [(_vm.property.ratings && _vm.property.ratings.salabam_score)?_c('score',{attrs:{"direction":'row',"rating":_vm.property.ratings.salabam_score,"floating":""}}):_vm._e()]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticClass:"flex-grow-1 d-flex justify-content-between align-items-center small text-muted"},[_c('div',{staticClass:"small"},[_vm._v(" "+_vm._s(_vm.format_booking_dates_range({ date_start: _vm.checkin, date_end: _vm.checkout, }))+" ")]),_c('div',{staticClass:"small d-flex align-items-center gap-2",staticStyle:{"gap":"5px"}},[_c('span',[_vm._v(" a partire da ")]),(!_vm.is_placeholder)?_c('rate-amount',{attrs:{"prices":_vm.property_pricing,"rate_only":""}}):_c('span',{staticClass:"bold text-info",staticStyle:{"font-size":"23px"}},[_vm._v(" € ---.-- ")])],1)])]},proxy:true}],null,true)})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }